import { render, staticRenderFns } from "./WorkDetailTask.vue?vue&type=template&id=98108bc0&scoped=true"
import script from "./WorkDetailTask.vue?vue&type=script&lang=js"
export * from "./WorkDetailTask.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailTask.vue?vue&type=style&index=0&id=98108bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98108bc0",
  null
  
)

export default component.exports